import { ChangeDetectionStrategy, Component } from '@angular/core';
import { takeUntilDestroyed } from '@angular/core/rxjs-interop';
import { Title } from '@angular/platform-browser';
import { MenuSharedFacade, SlideViewerFacade } from '@medsurf/flat-facades';
import { MediaControlService } from '@medsurf/flat-services';

@Component({
    selector: 'medsurf-print',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './print.component.html',
    styleUrls: ['./print.component.scss'],
    standalone: false
})
export class PrintComponent {
  /**
   * Constructor
   *
   * @param slideViewerFacade
   * @param menuSharedFacade
   * @param mediaControlService
   */
  public constructor(public slideViewerFacade: SlideViewerFacade,
                     public menuSharedFacade: MenuSharedFacade,
                     public mediaControlService: MediaControlService,
                     public titleService: Title) {

    this.menuSharedFacade.currentSlideTitle$.pipe(takeUntilDestroyed()).subscribe((title) => {
      this.titleService.setTitle(title);
    });
  }
}

